import { jsxs, jsx } from 'react/jsx-runtime';
import { Trans } from '@lingui/react';
import { button } from '@tecsinapse/cortex-core';
import { Button, Loading } from '@tecsinapse/cortex-react';
import { useMutation } from '@tanstack/react-query';
import { markAllViewed } from '../../core/data/mutation.js';
import { useCoreQuery } from '../../core/hooks/use-core-query.js';
import { useMenuAxios } from '../../core/context/axios.js';

const Footer = ({
  linkPortal
}) => {
  const {
    instance
  } = useMenuAxios();
  const {
    mutateAsync,
    isPending
  } = useMutation({
    mutationFn: () => markAllViewed(instance)
  });
  const {
    refetch
  } = useCoreQuery();
  const handleRead = async () => {
    try {
      await mutateAsync();
      await refetch();
    } catch (error) {
      console.error(error);
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex justify-between items-center p-mili hover:bg-secondary-light hover:cursor-pointer gap-x-deca", children: [
    /* @__PURE__ */ jsx("a", { className: button({
      className: "flex-1 no-underline"
    }), href: `${linkPortal}/notificacoes`, target: "_self", children: /* @__PURE__ */ jsx(Trans, { .../*i18n*/
    {
      id: "8b7AZk"
    } }) }),
    /* @__PURE__ */ jsxs(Button, { variants: {
      className: "flex-1",
      variant: "outline"
    }, onClick: handleRead, disabled: isPending, children: [
      isPending ? /* @__PURE__ */ jsx(Loading, {}) : null,
      /* @__PURE__ */ jsx(Trans, { .../*i18n*/
      {
        id: "Oe3qd7"
      } })
    ] })
  ] });
};

export { Footer };
